<template>
  <div id="bd-cuw">
    <el-input
      size="mini"
      placeholder="搜索"
      suffix-icon="el-icon-search"
      v-model="filterCUW"
    ></el-input>
    <el-tree
      class="filter-tree"
      :highlight-current="true"
      :data="allCuws"
      :props="defaultProps"
      default-expand-all
      :filter-node-method="filterCUWNode"
      @node-click="handleCUWNodeClick"
      ref="treeCUW"
    >
    </el-tree>
    <div style="margin-top: 15px; float: left;">
      <el-dropdown style="margin-right: 5px; float: left;">
        <el-button type="success" size="mini">
          {{ $t("add") }}<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="addCategory">{{
            $t("category")
          }}</el-dropdown-item>
          <el-dropdown-item @click.native="addCUW">{{
            $t("cuw")
          }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button
        @click="editCUW()"
        type="primary"
        size="mini"
        style="margin-right: -5px; float: left;"
        :disabled="editButtonDisabled"
        >{{ $t("edit") }}</el-button
      >
      <el-button
        @click="deleteCUW()"
        type="danger"
        size="mini"
        style="float: left;"
        :disabled="deleteButtonDisabled"
        >{{ $t("delete") }}</el-button
      >
    </div>
    <el-dialog
      v-dialogDrag
      :title="addCuwTip"
      :visible.sync="addCuwDialogVisible"
      width="30%"
      center
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item :label="titleTip" prop="name">
          <el-input v-model="form.name" :placeholder="titleTip"></el-input>
        </el-form-item>
        <el-form-item :label="contentTip" prop="content">
          <el-input
            type="textarea"
            :autosize="{ minRows: 10, maxRows: 20 }"
            v-model="form.content"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item :label="belongGroupTip" prop="categoryId" v-if="!isEdit">
          <span v-if="allCuws[0].cuwChildren.length === 0">{{ $t('pleaseCreateAtLeaseOneGroupFirst') }}</span>
          <el-radio-group v-model="form.categoryId">
            <el-radio v-for="category in allCuws[0].cuwChildren" :key="category.id" :label="category.id">{{ category.name }}</el-radio>
          </el-radio-group>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addCuwDialogVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button type="primary" @click="doAddCuw()">{{ $t("ok") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as constants from "@/util/constants";
import bus from "@/util/eventbus";

export default {
  name: "bd-cuw",
  data() {
    return {
      isEdit: false,
      addCuwDialogVisible: false,
      currentSelectedNote: {
        id: 0,
        name: "",
        content: "",
        type: "",
        categoryId: 0,
        cuwChildren: [],
      },
      form: {
        id: 0,
        name: "",
        content: "",
        categoryId: "",
        cuwChildren: [],
      },
      rules: {
        name: [{ required: true, message: "请输入标题", trigger: "blur" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        categoryId: [
          { required: true, message: "请至少选择一个分组", trigger: "change" },
        ],
      },
      emptyText: "暂无数据",
      filterCUW: "",
      defaultProps: {
        children: "cuwChildren",
        label: "name",
      },
    };
  },
  computed: {
    ...mapGetters(["allCuws"]),
    searchTip() {
      return this.$t("search");
    },
    addCuwTip() {
      return this.$t("addCuw");
    },
    titleTip() {
      return this.$t("title");
    },
    contentTip() {
      return this.$t("content");
    },
    belongGroupTip() {
      return this.$t("belongGroup");
    },
    editButtonDisabled() {
      for (let i = 0; i < this.allCuws[0].cuwChildren.length; i++) {
        const category = this.allCuws[0].cuwChildren[i];
        if (category.id === this.currentSelectedNote.id) {
          return false;
        }
        for (let j = 0; j < category.cuwChildren.length; j++) {
          const cuw = category.cuwChildren[j];
          if (cuw.id === this.currentSelectedNote.id) {
            return false;
          }
        }
      }
      return true;
    },
    deleteButtonDisabled() {
      for (let i = 0; i < this.allCuws[0].cuwChildren.length; i++) {
        const category = this.allCuws[0].cuwChildren[i];
        if (category.id === this.currentSelectedNote.id) {
          if (category.cuwChildren.length > 0) {
            return true;
          }
          return false;
        }
        for (let j = 0; j < category.cuwChildren.length; j++) {
          const cuw = category.cuwChildren[j];
          if (cuw.id === this.currentSelectedNote.id) {
            return false;
          }
        }
      }
      return true;
    },
  },
  watch: {
    filterCUW(val) {
      this.$refs.treeCUW.filter(val);
    },
  },
  methods: {
    ...mapActions([
      "createCategory",
      "updateCategory",
      "deleteCategory",
      "cuwCreate",
      "cuwUpdate",
      "cuwDelete",
    ]),
    filterCUWNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleCUWNodeClick(data) {
      // console.log(data)
      if (data.id === 0 || data.id === -1 || data.id === -2) {
        this.currentSelectedNote.id = 0;
        return;
      }
      //
      this.currentSelectedNote.id = data.id;
      this.currentSelectedNote.name = data.name;
      this.currentSelectedNote.type = data.type;
      if (data.type === constants.CATEGORY_TYPE_CUW_MINE) {
        this.currentSelectedNote.cuwChildren = data.cuwChildren;
      } else {
        // 快捷回复
        // FIXME: 直接在编辑对话框修改分组
        // this.currentSelectedNote.categoryId = data.category.id
        this.currentSelectedNote.content = data.content;
      }
      // 事件总线广播事件
      if (data.content !== null && data.content !== undefined) {
        bus.$emit(constants.EVENT_BUS_SELECT_CUW, data.content);
      }
    },
    // 分类
    addCategory() {
      this.$prompt("请输入分组", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          console.log(value);
          if (value !== undefined && value !== null && value.length > 0) {
            let payload = {
              parent_id: 0,
              name: value,
              type: constants.CATEGORY_TYPE_CUW_MINE,
            };
            this.createCategory(payload);
          }
        })
        .catch(() => {
          // 取消
        });
    },
    addCUW() {
      this.isEdit = false;
      this.addCuwDialogVisible = true;
    },
    doAddCuw() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.addCuwDialogVisible = false;
          if (this.isEdit) {
            //
            let payload = {
              id: this.form.id,
              name: this.form.name,
              content: this.form.content,
            };
            this.cuwUpdate(payload);
            this.currentSelectedNote.id = 0;
          } else {
            //
            let payload = {
              categoryId: this.form.categoryId,
              name: this.form.name,
              content: this.form.content,
            };
            this.cuwCreate(payload);
          }
        } else {
          return false;
        }
      });
    },
    editCUW() {
      this.isEdit = true;
      //
      this.form.id = this.currentSelectedNote.id;
      this.form.name = this.currentSelectedNote.name;
      if (this.currentSelectedNote.type === constants.CATEGORY_TYPE_CUW_MINE) {
        // 分组
        this.$prompt("编辑分组", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputValue: this.form.name,
        })
          .then(({ value }) => {
            // console.log(value)
            if (value !== undefined && value !== null && value.length > 0) {
              let payload = { category_id: this.form.id, name: value };
              this.updateCategory(payload);
              this.currentSelectedNote.id = 0;
            }
          })
          .catch(() => {
            // 取消
          });
      } else {
        // 快捷回复
        this.form.categoryId = this.currentSelectedNote.categoryId;
        this.form.content = this.currentSelectedNote.content;
        this.addCuwDialogVisible = true;
      }
    },
    deleteCUW() {
      if (this.currentSelectedNote.cuwChildren.length > 0) {
        this.$message({
          message: "请首先删除子快捷回复",
          type: "warning",
        });
        return;
      }
      this.$confirm("确定要删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (
            this.currentSelectedNote.type === constants.CATEGORY_TYPE_CUW_MINE
          ) {
            // 分组
            this.deleteCategory(this.currentSelectedNote.id);
          } else {
            // 快捷回复
            this.cuwDelete(this.currentSelectedNote.id);
          }
          this.currentSelectedNote.id = 0;
        })
        .catch(() => {});
    },
  },
  created() {},
  mounted() {},
};
</script>

<style scoped>
#bd-cuw {
  height: 100%;
  width: 100%;
}
.filter-tree {
  margin-top: 10px;
  margin-bottom: 10px;
  height: 100%;
  overflow-y: scroll !important;
}
/* .el-tree-node__label {
  font-size: 12px !important;
} */
</style>
